import { Icon, IconName } from '@blueprintjs/core'
import React, { SFC } from 'react'

import classNames from 'classnames'

export const ActivityBarItem: SFC<{ icon: IconName | JSX.Element; label: string; active?: boolean }> = ({
  icon,
  label,
  active,
}) => {
  active = active || false
  const activityBarClassName = classNames('activity-bar__navlink', {
    'activity-bar__navlink--active': active,
  })

  return (
    <div className={activityBarClassName}>
      <Icon iconSize={32} icon={icon} title={false} />
      <label className="activity-bar__label">{label}</label>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/app/shared/components/activity-bar-item.tsx